
import { OrderActions, OrderActionTypes } from '../actions/order.actions';

export interface State {
  Loaded: boolean;
  Loading: boolean;
}

export const initialState: State = {
  Loaded: false,
  Loading: false
};

export function reducer(state = initialState, action: OrderActions): State {
  switch (action.type) {
    case OrderActionTypes.CreateOrder:
      return {...state, Loading: true, Loaded: false};

    case OrderActionTypes.LoadOrder:
      return {...state, Loading: false, Loaded: true};
    default:
      return state;
  }
}
